/* ═══════════════════════════════════════
   BioBodyBoost — Wishlist
   localStorage-based, no app required
   ═══════════════════════════════════════ */
(function () {
  'use strict';

  const KEY = 'bbb_wl';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  }
  function save(ids) {
    localStorage.setItem(KEY, JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent('bbb:wishlist', { detail: { ids, count: ids.length } }));
    syncCountBadges(ids.length);
  }
  function toggle(id) {
    const list = get();
    const idx = list.indexOf(String(id));
    if (idx > -1) list.splice(idx, 1);
    else list.push(String(id));
    save(list);
    return idx === -1;
  }
  function isIn(id) { return get().includes(String(id)); }

  function syncCountBadges(count) {
    document.querySelectorAll('[data-bbb-wl-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function heartHTML(active) {
    return `<svg class="bbb-wl-ico" width="18" height="18" viewBox="0 0 24 24"
      fill="${active ? '#ef4444' : 'none'}" stroke="${active ? '#ef4444' : 'currentColor'}"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
    </svg>`;
  }

  function findProductId(root) {
    if (root.dataset && root.dataset.productId) return root.dataset.productId;
    const child = root.querySelector('[data-product-id]');
    if (child) return child.dataset.productId;
    const link = root.querySelector('a[href*="/products/"]');
    if (link) {
      const m = link.href.match(/\/products\/([^/?#]+)/);
      if (m) return 'handle:' + m[1];
    }
    return null;
  }

  function injectHearts() {
    const list = get();
    document.querySelectorAll('.card__media:not([data-bbb-heart])').forEach(media => {
      const card = media.closest('[data-product-id], .card, product-card-link, [class*="product-card"]');
      const id = card ? findProductId(card) : null;
      if (!id) return;

      media.setAttribute('data-bbb-heart', id);

      const active = list.includes(String(id)) || list.includes(id);
      const btn = document.createElement('button');
      btn.className = 'bbb-wl-btn' + (active ? ' bbb-wl-btn--on' : '');
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.innerHTML = heartHTML(active);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const added = toggle(id);
        btn.classList.toggle('bbb-wl-btn--on', added);
        btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
        btn.innerHTML = heartHTML(added);
        btn.classList.add('bbb-wl-btn--pop');
        setTimeout(() => btn.classList.remove('bbb-wl-btn--pop'), 350);
      });

      media.appendChild(btn);
    });
  }

  window.bbbRenderWishlist = function (containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;
    const ids = get();
    if (!ids.length) {
      container.innerHTML = '<p class="bbb-acct-wl-empty">Your wishlist is empty. <a href="/collections/plant-based-vitamins-minerals">Browse supplements &rarr;</a></p>';
      return;
    }
    container.innerHTML = '<p class="bbb-acct-wl-loading">Loading wishlist&hellip;</p>';

    const promises = ids.map(id => {
      if (String(id).startsWith('handle:')) {
        const handle = String(id).slice(7);
        return fetch('/products/' + handle + '.js').then(r => r.ok ? r.json() : null).catch(() => null);
      }
      return fetch('/search/suggest.json?q=' + id + '&resources[type]=product&resources[limit]=1')
        .then(r => r.json())
        .then(data => data.resources && data.resources.results && data.resources.results.products && data.resources.results.products[0] || null)
        .catch(() => null);
    });

    Promise.all(promises).then(products => {
      const valid = products.filter(Boolean);
      if (!valid.length) {
        container.innerHTML = '<p class="bbb-acct-wl-empty">Could not load wishlist products. <a href="/collections/all">Browse all</a></p>';
        return;
      }
      container.innerHTML = '<div class="bbb-acct-wl-grid">' +
        valid.map(p => {
          const img = (p.images && p.images[0]) || p.featured_image || '';
          const price = (p.price / 100).toFixed(2);
          const id = String(p.id);
          return '<div class="bbb-acct-wl-card">' +
            '<div class="bbb-acct-wl-img-wrap">' +
            (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '') +
            '<button class="bbb-acct-wl-remove" data-wl-id="' + id + '" title="Remove from wishlist" type="button">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
            '</div>' +
            '<div class="bbb-acct-wl-info">' +
            '<a class="bbb-acct-wl-title" href="/products/' + p.handle + '">' + p.title + '</a>' +
            '<span class="bbb-acct-wl-price">&pound;' + price + '</span>' +
            '<a class="bbb-acct-wl-atc" href="/products/' + p.handle + '">View product</a>' +
            '</div></div>';
        }).join('') + '</div>';

      container.querySelectorAll('[data-wl-id]').forEach(btn => {
        btn.addEventListener('click', function () {
          const pid = this.dataset.wlId;
          toggle(pid);
          window.bbbRenderWishlist(containerId);
        });
      });
    });
  };

  window.bbbWishlist = { get, toggle, isIn, count: () => get().length };

  function init() {
    injectHearts();
    syncCountBadges(get().length);
    const observer = new MutationObserver(injectHearts);
    const target = document.querySelector('[data-collection-results], .paginated-list, .collection, main');
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();